import { Stack } from "@mui/material";
import { ListHeader } from "../../../../components/Common";
import { NetworkStats, NetworkTrendGraphCard } from "./components";
import TopShareholdersTable from "../../components/Organisms/TopShareholdersTable/TopShareholdersTable";

const AllNetwork = () => {
  return (
    <Stack
      px={10}
      pb={10}
      width="100%"
      maxWidth={1440}
      m="0 auto"
      data-testid="all-network-page"
    >
      <ListHeader title="Network" sx={{ pb: 8 }} />
      <NetworkStats />
      <NetworkTrendGraphCard />
      <TopShareholdersTable />
    </Stack>
  );
};

export default AllNetwork;
